import React from 'react';
import dayjs from 'dayjs';
import { CalendarIcon } from 'components/common/icons';
import { ValidationErrors } from 'constants/validations';
import { Col, DatePicker, Form, FormModal, Row } from 'components';
import { useConfirmOrder } from './useConfirmOrder';

const { Item } = Form;

export interface IShippingUpdate {
  onCancel: () => void;
  open: boolean;
}

export const ConfirmOrderModal = React.memo((props: IShippingUpdate) => {
  const { onCancel: onCancelModal, open } = props;
  const { form, isLoadingUpdate, onFinish, onCancel } = useConfirmOrder({
    onCancelModal,
  });

  return (
    <FormModal
      form={form}
      title={'Confirm Order'}
      okText={'Save'}
      open={open}
      width={400}
      isLoading={isLoadingUpdate}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Item
            label="Confirmed Shipping Date*"
            name="shippingDate"
            rules={[{ required: true, message: ValidationErrors.required('Confirmed Shipping Date') }]}
          >
            <DatePicker
              size={'large'}
              style={{ width: '100%' }}
              suffixIcon={<CalendarIcon />}
              disabledDate={(current) => {
                return current && current < dayjs().startOf('day');
              }}
            />
          </Item>
        </Col>
        <Col span={24}>
          <Item
            label="Expected Arrival Date*"
            name="expectedArrivalDate"
            rules={[{ required: true, message: ValidationErrors.required('Confirmed Shipping Date') }]}
          >
            <DatePicker
              size={'large'}
              style={{ width: '100%' }}
              suffixIcon={<CalendarIcon />}
              disabledDate={(current) => {
                return current && current < dayjs().startOf('day');
              }}
            />
          </Item>
        </Col>
      </Row>
    </FormModal>
  );
});
